import api, { ApiResponse } from './api';

import { LoadProfile } from 'entities/LoadProfile';

interface GetLoadProfileListResponse {
  success: boolean;
  data: LoadProfile[];
}

export const getLoadProfileListService =
  (): ApiResponse<GetLoadProfileListResponse> =>
    api({
      method: 'GET',
      url: 'load-profiles',
      useToken: true,
    });
